var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightoutlinedone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23071 6.64471L0.280712 1.69471C0.0985538 1.50611 -0.00224062 1.25351 3.78026e-05 0.991311C0.00231622 0.729114 0.107485 0.478301 0.292893 0.292893C0.478301 0.107485 0.729114 0.00231622 0.991311 3.78026e-05C1.25351 -0.00224062 1.50611 0.0985538 1.69471 0.280712L7.35171 5.93771C7.53918 6.12524 7.6445 6.37955 7.6445 6.64471C7.6445 6.90988 7.53918 7.16418 7.35171 7.35171L1.69471 13.0087C1.50611 13.1909 1.25351 13.2917 0.991311 13.2894C0.729114 13.2871 0.478301 13.1819 0.292893 12.9965C0.107485 12.8111 0.00231622 12.5603 3.78026e-05 12.2981C-0.00224062 12.0359 0.0985538 11.7833 0.280712 11.5947L5.23071 6.64471Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightoutlinedone);
export default __webpack_public_path__ + "static/media/rightoutlinedone.6822080c9b69690e56e2a104c26e00d1.svg";
export { ForwardRef as ReactComponent };